// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nf-0";
export var buttonContainer = "_nf-3";
export var cancelButton = "_nf-4";
export var headerSection = "_nf-6";
export var headerTitle = "_nf-9";
export var messageSideLeft = "_nf-1";
export var messageSideRight = "_nf-2";
export var orderNumberContainer = "_nf-7";
export var orderNumberLabel = "_nf-8";
export var submitButton = "_nf-5";